<template>
  <div class="c-playlists-name-expand-function">
    <div class="cover-name">
      <a :href="`/explore/albums-info/${data.album?.albumUid || data.track?.album?.albumUid}`">
        <img class="cover-name__cover" :src="imageSource(data.track?.artworkInfo || data.album?.artworkInfo || '')" />
      </a>
      <a class="cover-name__name" :href="`/search/?type=${data.type === 'Tracks' ? 'tracks' : 'albums'}&uid=${data.type === 'Tracks' ? data.track?.trackUid : data.album?.albumUid
        }`" target="_blank">{{ data.album?.albumTitleDisplay || data.track?.trackTitleDisplay }}
      </a>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import imageSource from '@/utils/imageSource';

export default defineComponent({
  name: 'PlaylistsNameExpandFunction',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    column: {
      type: Object,
      default: () => ({}),
    },
    idx: {
      type: Number,
    },
    toSearch: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      imageSource,

    };
  },
});
</script>
<style lang="scss" scoped>
.c-playlists-name-expand-function {
  width: 100%;
  @include flex();
  max-width: 500px;
}

.cover-name {
  flex: none;
  width: 100%;
  // width: 300px;
  @include flex();

  &__cover {
    width: 30px;
    height: 30px;
  }

  &__name {
    flex: 1;
    width: 100%;
    margin-left: 16px;
    @include font-style($c-black, 14, bold, 0.8px, 26px);
    @include word-ellipsis(1);
  }
}
</style>
